module.exports = __webpack_public_path__ + "static/media/male2.c67e2772.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/body-model/male2.png
// module id = 895
// module chunks = 0